import { gfs } from '../../utils/functional'
import { keys } from 'ramda'

const UPDATE_SHOW_MOBILE_MESSAGE = 'UPDATE_SHOW_MOBILE_MESSAGE'
const CLEAR_SHOW_MOBILE_MESSAGE = 'CLEAR_SHOW_MOBILE_MESSAGE'
const UPDATE_WORKBENCH_QR_CODE = 'UPDATE_WORKBENCH_QR_CODE'
const state = {
  showMobileMessage: true,
  workBenchQrcode: null
}
export default {
  namespaced: false,
  state,
  mutations: {
    [UPDATE_SHOW_MOBILE_MESSAGE](state, data) {
      state.showMobileMessage = false
    },
    [CLEAR_SHOW_MOBILE_MESSAGE](state, data) {
      state.showMobileMessage = true
    },
    [UPDATE_WORKBENCH_QR_CODE](state, data) {
      state.workBenchQrcode = data
    }
  },
  actions: {
    upDateShowMobileMessage({ commit }) {
      commit(UPDATE_SHOW_MOBILE_MESSAGE)
    },
    clearShowMobileMessage({ commit }, params) {
      commit(CLEAR_SHOW_MOBILE_MESSAGE, params)
    },
    workbenchQrCodeChange({ commit }, params) {
      commit(UPDATE_WORKBENCH_QR_CODE, params)
    }
  },
  getters: {
    ...gfs(keys(state))
  }
}
